import React from "react";
import { IPerson } from "../../../interfaces";
import Disclosure from "../Disclosure/Disclosure";
import ShortPersonCard from "./ShortPersonCard";


interface ProfessionalsSectionProps {
  professionals: IPerson[];
}

const ProfessionalsSection: React.FC<ProfessionalsSectionProps> = ({ professionals }) => {
  const titles = ['Executive', 'Partners', 'Associates', 'Counsel'];

  return (
    <div className="flex px-7 py-7 gap-5 lg:py-11 lg:px-12 flex-col items-end lg:gap-[1.75rem] self-stretch">
      <div className="flex flex-col items-start gap-[1.75rem] md:gap-6 self-stretch">
        {titles.map(title => {
          const filteredProfessionals = professionals.filter(person => person.title === title);
          if (filteredProfessionals.length === 0) {
            return null;
          }
          return (
            <React.Fragment key={title}>
              <div className="flex items-center gap-4 self-stretch">
                <span className="font-decimal lg:text-lg lg:leading-5 font-medium text-primary">
                  {title}
                </span>
                <hr className="flex h-0 justify-center flex-1" />
              </div>
              <div className="flex flex-col items-start gap-5 lg:items-end lg:gap-[1.125rem] self-stretch">
                <div className=" p-0 gap-5 md:items-start md:justify-start md:gap-[1.5rem] self-stretch grid grid-cols-2 lg:grid-cols-3">
                  {filteredProfessionals.map((person: IPerson) => (
                    <ShortPersonCard key={person.id} person={person} />
                  ))}
                </div>
              </div>
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

const Professionals: React.FC<{ professionals: IPerson[] }> = ({ professionals }) => {
  const personCount = professionals.length;

  return (
    <Disclosure title="Professionals" isCardOpen={personCount > 0} onCardOpen={() => ''} color="primary">
      <ProfessionalsSection professionals={professionals} />
    </Disclosure>
  );
};

export default Professionals;